<div class="flex pl-2 pr-2 pb-2 mt-2 border-bottom filter-container items-center">
  <mat-form-field subscriptSizing="dynamic">
    <mat-icon matPrefix>filter_alt</mat-icon>
    <input
      [formControl]="filter"
      [placeholder]="
        'personal_content.titles.search_in_nibbles'
          | transloco : { value: nibbles && nibbles.length > 0 ? nibbles.length : 0 }
      "
      class="filter-input"
      matNativeControl
    />
    @if (filter.value) {
    <button (click)="filter.patchValue('')" mat-icon-button matSuffix>
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>

  @if (collection.type === 'trashbin') {
  <button (click)="onDeleteAll()" [title]="'personal_content.titles.delete_all_nibbles' | transloco" mat-icon-button>
    <mat-icon>delete</mat-icon>
  </button>
  }
</div>

@if (data.length === 0) {
<div class="text-center p-3">
  {{ 'personal_content.messages.collection_no_nibbles' | transloco }}
</div>
} @if (data.length > 0) {
<div class="viewport overflow-auto">
  <div
    (cdkDropListDropped)="drop($event)"
    [cdkDropListData]="filteredData$ | async"
    cdkDropList
    cdkDropListLockAxis="y"
  >
    @for (nibble of filteredData$ | async; track nibbleById(i, nibble); let i = $index; let isLast = $last) {
    <div [id]="'nibble-list-' + nibble.nibble.id" cdkDrag class="virtual-item-container">
      <div *cdkDragPlaceholder class="example-custom-placeholder"></div>
      <div
        [ngClass]="[
          'h-full',
          'flex',
          'flex-auto',
          'justify-between',
          'items-center',
          'p-2',
          !isLast ? 'border-bottom' : '',
          highlightId === nibble.nibble.id ? 'active' : ''
        ]"
      >
        <div class="flex flex-auto items-center">
          <div class="p-2 mx-3">
            @if (!bulkEdit) {
            <mat-icon [title]="'personal_content.buttons.move' | transloco" cdkDragHandle class="nibble-drag-icon"
              >drag_handle
            </mat-icon>
            } @if (bulkEdit) {
            <mat-checkbox
              (change)="selectionChange.emit([nibble, $event.checked])"
              [checked]="getSelected(nibble)"
            ></mat-checkbox>
            }
          </div>
          <!-- eslint-disable-next-line -->
          <div
            (click)="onNibbleOpen(nibble, i)"
            [title]="nibble.clientInfo.shortLabel"
            class="flex flex-auto items-center cursor-pointer"
          >
            <pc-nibble-type-icon
              [disabled]="!nibble.nibble.relations.ownedByCurrentUser"
              [type]="nibble.nibble.type"
              class="mr-4"
            ></pc-nibble-type-icon>
            @if (hasThumb(nibble)) {
            <aipb-image [fullWidth]="true" [src]="getThumb(nibble)" class="mr-2" height="75"></aipb-image>
            }
            <div class="flex flex-col gap-1">
              @if(nibble.clientInfo.headerHtml) {
              <div [innerHTML]="nibble.clientInfo.headerHtml | safehtml"></div>
              } @else {
              <div>{{ nibble.clientInfo.shortLabel | striphtml : ' ' | shorten : 30 }}</div>
              } @if (nibble.clientInfo.note) {
              <div class="text-xs text-gray-500">
                {{ nibble.clientInfo.note }}
              </div>
              }
            </div>
          </div>
        </div>
        <div class="flex">
          <button (click)="onEditNibble(nibble)" [title]="'personal_content.buttons.edit' | transloco" mat-icon-button>
            <mat-icon class="text-secondary">edit</mat-icon>
          </button>
          <pc-shared-nibble-menu
            (updateNibble)="copyMoveEnded.emit($event)"
            [collection]="collection"
            [context]="context"
            [nibbleCut]="nibble"
            [position]="i"
          ></pc-shared-nibble-menu>
        </div>
      </div>
    </div>
    }
  </div>
</div>
}
